<div class="about">
    <h3 class="about-title">Play For what ? C'est quoi ça ?</h3>
    <p class="about-text">
        Le Play For Good (PFG) est un évènement gaming caritatif créé par PULS IMPACT.<br> Le but est de proposer aux
        citoyens de passer un bon moment en jouant à un ou des jeux vidéo originaux tout en soutenant des associations
        caritatives de façon ludique.<br> Au travers du PFG, nous souhaitons évidemment amener les citoyens à l’acte de
        dons.</p>
</div>
